import { FaWhatsapp, FaPhone } from 'react-icons/fa';
import { useSettings } from '../context/SettingsContext';

export default function FloatingButtons() {
  const { settings } = useSettings();

  if (!settings.whatsapp && !settings.phone) return null;

  return (
    <div className="floating-buttons">
      {settings.whatsapp && (
        <a
          href={`https://wa.me/${settings.whatsapp}?text=${encodeURIComponent('Merhaba, web sitenizden ulaşıyorum. Bilgi almak istiyorum.')}`}
          target="_blank"
          rel="noopener noreferrer"
          className="float-btn whatsapp"
          aria-label="WhatsApp"
        >
          <FaWhatsapp />
        </a>
      )}
      {settings.phone && (
        <a
          href={`tel:${settings.phone}`}
          className="float-btn phone"
          aria-label="Telefon"
        >
          <FaPhone />
        </a>
      )}
    </div>
  );
}
